<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :timeout="timeout"
    top
    right
  >
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="snackbar = false"
      >
        Cerrar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AlertSnackbar',
  data: () => ({
    snackbar: false,
    message: '',
    color: 'success',
    timeout: 5000
  }),
  methods: {
    showAlert(options) {
      this.message = options.message;
      this.color = options.type || 'success';
      this.timeout = options.timeout || 5000;
      this.snackbar = true;
    }
  }
};
</script> 